import { useCallback, useMemo } from 'react';

import dayjs from 'dayjs';

import { Props as DatePickerProps } from 'e100-react-components/lib/components/DatePicker/types';

import { useFilterFormContext } from '../context';

export const useShouldDisableEndDate = () => {
  const { startDate } = useFilterFormContext();

  const changedStartDate = useMemo(() => (
    dayjs(startDate).subtract(1, 'day').format()
  ), [startDate]);

  const shouldDisableEndDate: DatePickerProps['shouldDisableDate'] = useCallback((date: any) => {
    return !date.isAfter(changedStartDate);
  }, [changedStartDate]);

  return shouldDisableEndDate;
};
